import { UserRole } from "@/types";

export const PaymentsFilterRole = {
  ...UserRole,
  Affiliate: "affiliate",
} as const;

export type PaymentsFilterRole =
  (typeof PaymentsFilterRole)[keyof typeof PaymentsFilterRole];

export type PaymentsListFilter = {
  search?: string;
  roles?: PaymentsFilterRole[];
};
